import { officeCountry } from "./detectCountry";

export const WHATSAPP_PHONE = {
  NG: "00234 706 289 4508",
  CD: "00243 846 324 098",
};

export const WHATSAPP_CONVERSION = {
  NG: "AW-17266121186/gAukCMOfp-gcEOKzkKlA",
  CD: "AW-17266121186/gAukCMOfp-gcEOKzkK1A",
};

export function toWhatsAppNumber(raw) {
  return String(raw || "")
    .replace(/\D/g, "")
    .replace(/^00/, "");
}

export function whatsAppUrl(country) {
  const office = officeCountry(country);
  const raw = office === "NG" ? WHATSAPP_PHONE.NG : WHATSAPP_PHONE.CD;
  return `https://wa.me/${toWhatsAppNumber(raw)}`;
}

export function reportWhatsAppConversion(country) {
  const sendTo =
    officeCountry(country) === "NG"
      ? WHATSAPP_CONVERSION.NG
      : WHATSAPP_CONVERSION.CD;
  if (!sendTo || typeof window === "undefined") {
    return;
  }
  window.gtag?.("event", "conversion", { send_to: sendTo });
}
